import { render } from "./EncounterInfoComponent.vue?vue&type=template&id=54b66425&scoped=true"
import script from "./EncounterInfoComponent.vue?vue&type=script&lang=js"
export * from "./EncounterInfoComponent.vue?vue&type=script&lang=js"

import "./EncounterInfoComponent.vue?vue&type=style&index=0&id=54b66425&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b66425"]])

export default __exports__